import React, { Component } from 'react'
import { Grid, Cell } from 'react-mdl'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {faHackerrank} from '@fortawesome/free-solid-svg-icons'
export class landingpage extends Component {
    render() {
        return (
            <div style={{width:'100%',margin:'auto'}}>
                <Grid className="landing-grid">
                    <Cell col={12}>
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSr1OGM_q7SNDpz7NBUp_3LjldGAN5WubFscg&usqp=CAU" alt="avatar" className="avatar-img"/>
                        <div className="banner-text">
                            <h1>Full Stack Developer</h1>
                            <hr/>
                            <p>HTML | CSS | JavaScript | React | Angular | NodeJS | Express | MongoDB </p>
                            <div className="social-links">
                                {/* Linkedin */}
                                <a href="https://www.linkedin.com/in/chakka-yamini-665257128/" rel="noopener noreferrer" target="_blank">
                                <i class="fa fa-linkedin-square" aria-hidden="true"></i></a>
                                {/* github */}
                                <a href="https://github.com/yamini465" rel="noopener noreferrer" target="_blank">
                                <i className="fa fa-github-square" aria-hidden="true"></i></a>
                                 {/* Bitbucket */}
                                 <a href="https://bitbucket.org/yaminichakka/" rel="noopener noreferrer" target="_blank">
                                 <i class="fa fa-bitbucket-square" aria-hidden="true"></i></a>
                                 {/*Hackerrank */}
                                 {/* <a href="https://www.hackerrank.com/yaminikanakarao" rel="noopener noreferrer" target="_blank">
                                 <i class="fab fa-hackerrank-square"></i></a> */}
                            </div>
                        </div>
                    </Cell>
                </Grid>
            </div>
        )
    }
}

export default landingpage;
